<template>
  <div
    class="mt-2 container vh-100 d-flex flex-column justify-content-lg-center align-items-center"
  >
    <div
      class="card card-deal text-center text-white bg-ek2024"
    >
      <div class="card-header">
        <div class="d-none d-md-flex justify-content-center">
          <h1
            class="text-white"
          >
            EK commercial competitie 2024
          </h1>
        </div>

        <div class="d-flex d-md-none flex-column align-items-center">
          <h4
            class="text-white"
          >
            EK commercial competitie 2024
          </h4>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="text-white col-md-6 mb-3">
            <h1 class="text-smaller">
              Hebben jullie de beste en meest opvallende EK commercial van 2024?
            </h1>

            <p>
              Dit jaar organiseert commercialreview de EK commercial competitie van 2024.
              Meld je commercial nu aan zodat Nederland kan stemmen op jullie commercial.
              Alle deelnemende commercials krijgen veel extra aandacht via onze Instagram,
              LinkedIn, en nieuwsbrief. Daarnaast verzamelen we veel feedback en data en publiceren
              we de uitslagen in juli via onze kanalen.
            </p>

            <hr/>

            <div class="mb-3">
              <v-button
                size="sm"
                :icon="showBenchmarkInfo ? 'times': 'info'"
                style-type="secondary"
                :text="showBenchmarkInfo ? 'phrase.less_info': 'phrase.more_info'"
                @click="showBenchmarkInfo = !showBenchmarkInfo"
              />
            </div>

            <v-collapse-transition>
              <div class="card-body bg-light text-left" v-if="showBenchmarkInfo">
                <v-check-six-categories
                  title="Benchmarking van je commercial op 6 dimensies"
                />
                <hr/>
                <div>
                  <i class="fa fa-check text-success"></i>
                  Per commercial stellen we standaard {{ ITEMS.length }} vragen
                  <v-button
                    style-type="secondary"
                    size="xs"
                    :text="`word.${showItems ? 'hide' : 'show'}`"
                    :rounded="true"
                    @click="showItems = !showItems"
                  />
                  <v-collapse-transition>
                    <div class="mt-2 p-0 card bg-dark text-white" v-if="showItems">
                      <ul class="m-4">
                        <li
                          v-for="(item, index) in ITEMS"
                          :key="index"
                        >
                          <small>{{ item }}</small>
                        </li>
                      </ul>
                    </div>
                  </v-collapse-transition>
                </div>
                <hr/>
                <v-check-add-custom-question/>
                <hr/>
                <v-check-number-of-reviewers/>
                <hr/>
                <v-check-commercial-dashboard/>
                <hr/>
                <div>
                  <i class="fa fa-check text-success"></i>
                  Resultaten commercial t.o.v. verschillende benchmarks
                </div>
                <hr />
                <v-check-csv-export/>
                <hr/>
                <v-check-commercial-promoted/>
              </div>
            </v-collapse-transition>

          </div>
          <div class="col-md-6 mb-3">
            <img
              src="@/common/assets/img/football.png"
              class="img-small"
              alt="reviewer"
            />

            <hr/>

            <h4>Deelname vanaf &euro; 599,-</h4>
            <div class="font-italic">
              Meld jouw commercial nu aan!
            </div>

            <hr/>

            <v-button
              icon="trophy"
              text="word.register"
              style-type="warning"
              @click="goToWizard()"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="mt-3 mb-3 w-100">
      <v-partner-carousel
        bg-class="bg-ek2024"
      />
    </div>
    <v-auth-modal
      v-if="selectedDeal !== null"
      sub-title="sentence.login_to_register_commercial"
      :title="`word.${selectedDeal}`"
      :closable="true"
      :as-organisation="true"
      @authenticated="goToRegisterCommercial"
      @hide-modal="selectedDeal = null"
    />
  </div>
</template>


<script>
import AuthModal from '@/common/components/auth/AuthModal.vue';
import Button from '@/common/components/Button.vue';
import PartnerCarousel from '@/common/components/carousels/PartnerCarousel.vue';
import AddCustomQuestion from '@/common/components/registration/AddCustomQuestion.vue';
import CommercialDashboard from '@/common/components/registration/CommercialDashboard.vue';
import CommercialPromoted from '@/common/components/registration/CommercialPromoted.vue';
import NumberOfReviewers from '@/common/components/registration/NumberOfReviewers.vue';
import CheckSixCategories from '@/common/components/registration/SixCategories.vue';
import CsvExport from '@/common/components/registration/CsvExport.vue';
import { CollapseTransition } from '@ivanv/vue-collapse-transition';
import { mapGetters } from 'vuex';
import { notify } from '@/common/utils/notify';

const ITEMS = [
  'Wat zijn je eerste gedachten over deze commercial?',
  'Heb je deze commercial al eerder gezien?',
  'In hoeverre vind je deze commercial leuk om naar te kijken?',
  'In hoeverre vind je deze commercial irritant?',
  'In hoeverre vind je deze commercial geloofwaardig?',
  'In hoeverre vind je deze commercial onderscheidend?',
  'In hoeverre zet de commercial je aan tot actie?',
  'Welk cijfer geef je deze commercial?',
];


export default {
  name: 'CommercialCreateStartChristmas',
  components: {
    'v-auth-modal': AuthModal,
    'v-button': Button,
    'v-partner-carousel': PartnerCarousel,
    'v-collapse-transition': CollapseTransition,
    'v-check-add-custom-question': AddCustomQuestion,
    'v-check-commercial-dashboard': CommercialDashboard,
    'v-check-commercial-promoted': CommercialPromoted,
    'v-check-number-of-reviewers': NumberOfReviewers,
    'v-check-six-categories': CheckSixCategories,
    'v-check-csv-export': CsvExport,
  },
  computed: {
    ...mapGetters(['user', 'org']),
    thisYear() {
      return new Date().getFullYear();
    },
  },
  data() {
    return {
      ITEMS,
      showBenchmarkInfo: false,
      showBenchmarkItems: false,
      showMarketingInfo: false,
      showMarketingItems: false,
      selectedDeal: null,
      showItems: false,
    };
  },
  methods: {
    goToWizard() {
      if (this.user.isAuthenticated) {
        this.$router.push({
          name: 'organisation-create-research',
          params: { researchType: 'ek-2024' },
        });
      } else {
        this.selectedDeal = 'competition';
      }
    },
    goToRegisterCommercial() {
      notify('phrase.logged_in', 'sentence.register_commercial');
      this.$router.push({
        name: 'organisation-create-research',
        params: { researchType: 'ek-2024' },
      });
    },
  },
};
</script>

<style scoped>
h1.text-smaller {
  font-size: 18px;
}

img.img-christmas {
  height: 100px;
  width: auto;
}

.bg-ek2024 {
  background: rgb(23, 28, 33);
}

img.img-small {
  height: 100px;
  width: auto;
}

.icon-deal {
  font-size: 80px;
}

.link-deal {
  color: #175194;
  transition: 0.2s all ease-in-out;
}

.link-deal:hover {
  color: white !important;
}
</style>
